var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteFilePaiementLetter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6542",
    "data-name": "Groupe 6542",
    transform: "translate(-766 -6113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6540",
    "data-name": "Groupe 6540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6538",
    "data-name": "Groupe 6538",
    transform: "translate(4 -3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(762 6116)",
    fill: "#fdd9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_62_-_Contour",
    "data-name": "Ellipse 62 - Contour",
    d: "M11,1A10,10,0,1,0,21,11,10.011,10.011,0,0,0,11,1m0-1A11,11,0,1,1,0,11,11,11,0,0,1,11,0Z",
    transform: "translate(762 6116)",
    fill: "#ff3e3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6437",
    "data-name": "Groupe 6437",
    transform: "translate(769.053 6123.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5687",
    "data-name": "Trac\\xE9 5687",
    d: "M3197.591,6271.88a.5.5,0,0,1-.354-.146l-7.893-7.893a.5.5,0,0,1,.707-.707l7.893,7.893a.5.5,0,0,1-.354.854Z",
    transform: "translate(-3189.698 -6263.487)",
    fill: "#ff3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5688",
    "data-name": "Trac\\xE9 5688",
    d: "M7.893,8.393a.5.5,0,0,1-.354-.146L-.354.354a.5.5,0,0,1,0-.707.5.5,0,0,1,.707,0L8.246,7.539a.5.5,0,0,1-.354.854Z",
    transform: "translate(7.893) rotate(90)",
    fill: "#ff3e3e"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFilePaiementLetter);
export default __webpack_public_path__ + "static/media/delete_file_paiement_letter.940617b9d157d10ca25dfdf8ea6f8117.svg";
export { ForwardRef as ReactComponent };